module.exports = __webpack_public_path__ + "static/media/info-icon.87b594d1.png";